var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        attrs: {
          id: "user@1x-a",
          d:
            "M14.4001666,9.12458287 L14.4001666,10.0433815 C14.4001666,11.3804227 13.3119712,12.4671858 11.9756494,12.4671858 C10.6382148,12.4671858 9.55113206,11.3804227 9.55113206,10.0433815 L9.55113206,9.44716352 L10.3511449,9.44716352 C11.3870446,9.44716352 12.3784374,9.07230256 13.1517461,8.39154616 L14.4001666,9.12458287 Z M13.4087738,6.79644049 C13.0994504,6.61624027 12.6799722,6.68854283 12.4507613,6.9621802 C11.928917,7.5839822 11.1633971,7.94104561 10.3511449,7.94104561 L9.55113206,7.94104561 L9.55113206,7.92880979 C9.55113206,6.59176863 10.6382148,5.50500556 11.9756494,5.50500556 C13.087211,5.50500556 14.0585756,6.27586207 14.3267301,7.33592881 L13.4087738,6.79644049 Z M11.9756494,15.3170189 C12.3906769,15.3170189 12.7289298,14.9799778 12.7289298,14.5650723 L12.7289298,13.9721913 L15.0922501,13.9721913 C16.9404021,13.9721913 18.4447377,15.4760845 18.4447377,17.3248053 L18.4447377,18.4938821 L5.50544832,18.4938821 L5.50544832,17.3248053 C5.50544832,15.4760845 7.00978397,13.9721913 8.85904865,13.9721913 L11.2223689,13.9721913 L11.2223689,14.5650723 C11.2223689,14.9799778 11.5606218,15.3170189 11.9756494,15.3170189 L11.9756494,15.3170189 Z M15.0922501,12.4671858 L15.0655459,12.4671858 C15.6096436,11.7764182 15.9067276,10.9243604 15.9067276,10.0433815 L15.9067276,7.92880979 C15.9067276,5.76307008 14.1431389,4 11.9756494,4 C9.80815982,4 8.04457106,5.76307008 8.04457106,7.92880979 L8.04457106,10.0433815 C8.04457106,10.9243604 8.3416551,11.7764182 8.88464016,12.4671858 L8.85904865,12.4671858 C6.17972895,12.4671858 4,14.6462736 4,17.3248053 L4,19.246941 C4,19.6618465 4.33825299,20 4.7532805,20 L19.1980182,20 C19.6130457,20 19.9512987,19.6618465 19.9512987,19.246941 L19.9512987,17.3248053 C19.9512987,14.6462736 17.7715698,12.4671858 15.0922501,12.4671858 L15.0922501,12.4671858 Z"
        }
      })
    ]),
    _vm._v(" "),
    _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
      _c("rect", {
        staticStyle: { "mix-blend-mode": "color-burn" },
        attrs: {
          width: "24",
          height: "24",
          fill: "#E3E3E3",
          "fill-opacity": ".01"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        staticStyle: { "mix-blend-mode": "color-burn" },
        attrs: {
          width: "24",
          height: "24",
          fill: "#E3E3E3",
          "fill-opacity": ".01"
        }
      }),
      _vm._v(" "),
      _c("use", {
        attrs: {
          fill: _vm.currentColor,
          opacity: _vm.opacity,
          "xlink:href": "#user@1x-a"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }